import { idToString, convertMonetaryValueToNumber, toInt } from '../util';

export const getPayloadForCategoryView = ({ category, userId }) => {
  const event_label = ['ca' + idToString(category.id)].join('--');

  const payload = {
    user_id: userId,
    event_label,
    category_id: toInt(category.id),
  };
  if (category.courses) {
    payload.items = category.courses
      .filter((course) => course.product)
      .map((course) => {
        return {
          category: idToString(course.formatId) + '/' + idToString(course.categoryId),
          id: toInt(course.product.id),
          name: course.product.title,
          origin_course_id: toInt(course.originCourseId || course.id),
          google_business_vertical: 'education',
          price: convertMonetaryValueToNumber(course.product.salePrice),
          quantity: toInt(course.product.quantity) || 1,
        };
      });
    payload.course_ids = category.courses.map((course) => idToString(course.id)).join(',');
    payload.origin_course_ids = Array.from(new Set(category.courses.map((course) => course.originCourseId)))
      .map((id) => idToString(id))
      .join(',');
  }
  return payload;
};

export const getPayloadForCourseView = ({ course, userId }) => {
  const product = course.products && course.products[0];
  const event_label = [
    'f' + idToString(course.formatId),
    'ca' + idToString(course.categoryId),
    'oc' + idToString(course.originCourseId),
  ].join('--');
  const page = course.page;

  const payload = {
    user_id: userId,
    slug: (page && page.slug) || '',
    event_label,
    category_id: toInt(course.categoryId),
    format_id: toInt(course.formatId),
    format_category_id: idToString(course.formatId) + '/' + idToString(course.categoryId),
    course_ids: toInt(course.id),
    origin_course_ids: toInt(course.originCourseId || course.id),
    edu_pid: course.id,
    edu_pagetype: 'program',
  };

  if (product) {
    payload.items = [
      {
        category: idToString(course.formatId) + '/' + idToString(course.categoryId),
        id: toInt(product.id),
        name: product.title,
        origin_course_id: toInt(course.originCourseId || course.id),
        google_business_vertical: 'education',
        price: convertMonetaryValueToNumber(product.salePrice),
        quantity: toInt(product.quantity) || 1,
      },
    ];
  } else {
    payload.items = [];
  }

  return payload;
};

export const getPayloadForSPA = ({ data, userId }) => {
  const { product, courses, bundle, customerId } = data;
  const event_label = ['f' + idToString(product.formatId), 'ca' + idToString(product.categoryId)].join('--');

  const payload = {
    user_id: userId,
    customer_id: customerId || '',
    event_label,
    value: product.salePrice || 0,
    currency: 'KRW',
    category: product.categoryId,
    title: product.title,
    id: product.id,
    event_category: 'ecommerce',
    category_id: product.categoryId,
    format_id: product.formatId,
    format_category_id: idToString(product.formatId) + '/' + idToString(product.categoryId),
    edu_pid: product.courseId,
    edu_totalvalue: convertMonetaryValueToNumber(product.salePrice),
    items: [
      {
        category: idToString(product.formatId) + '/' + idToString(product.categoryId),
        id: product.id,
        name: product.title,
        course_id: product.courseId || '',
        google_business_vertical: 'education',
        price: convertMonetaryValueToNumber(product.salePrice),
        quantity: product.quantity || 1,
      },
    ],
  };
  if (bundle) {
    const items = bundle.map((product) => {
      return {
        category: idToString(product.formatId) + '/' + idToString(product.categoryId),
        id: product.id,
        name: product.title,
        course_id: product.courseId || '',
        google_business_vertical: 'education',
        price: convertMonetaryValueToNumber(product.salePrice),
        quantity: product.quantity || 1,
      };
    });
    payload.items = payload.items.concat(items);
  }
  if (courses) {
    payload.course_ids = courses.map((course) => idToString(course.id)).join(',');
    payload.origin_course_ids = Array.from(new Set(courses.map((course) => course.originCourseId)))
      .map((id) => idToString(id))
      .join(',');
    payload.items = payload.items.map((product) => {
      const course = courses.find((course) => course.id === product.course_id);
      product.origin_course_id = (course && course.originCourseId) || '';
      return product;
    });

    if (!payload.edu_pid) {
      payload.edu_pid = courses[0]?.id;
    }
  }
  return payload;
};

export const getPayloadForTransactionPayment = ({ data, userId }) => {
  const { productSaleInfo, transactionInfo, userInfo } = data;
  const payload = {
    user_id: userId,
    currency: 'KRW',
    customer_id: (userInfo && userInfo.customerId) || '',
  };

  if (transactionInfo && transactionInfo.transaction) {
    const { amount, taxFreeAmount, id } = transactionInfo.transaction;
    payload.user_id = userId;
    payload.value = amount;
    payload.tax = amount - taxFreeAmount;
    payload.tax_free_amount = taxFreeAmount;
    payload.transaction_id = id;
  }

  if (transactionInfo && transactionInfo.coupons && Array.isArray(transactionInfo.coupons)) {
    payload.coupon_ids = transactionInfo.coupons.map((coupon) => idToString(coupon.id)).join(',');
  }

  if (productSaleInfo && productSaleInfo.product) {
    const { formatId, categoryId, title, id, salePrice, quantity, courseId } = productSaleInfo.product;
    payload.event_label = ['f' + idToString(formatId), 'ca' + idToString(categoryId)].join('--');
    payload.category = categoryId;
    payload.title = title;
    payload.id = id;
    payload.category_id = categoryId;
    payload.format_id = formatId;
    payload.format_category_id = idToString(formatId) + '/' + idToString(categoryId);
    payload.items = [
      {
        category: idToString(formatId) + '/' + idToString(categoryId),
        id: id,
        name: title,
        google_business_vertical: 'education',
        price: salePrice,
        quantity: quantity || 1,
        course_id: courseId || '',
      },
    ];
    payload.edu_totalvalue = salePrice;
  }

  if (productSaleInfo && productSaleInfo.bundle) {
    const items = productSaleInfo.bundle.map((product) => {
      return {
        category: idToString(product.formatId) + '/' + idToString(product.categoryId),
        id: product.id,
        name: product.title,
        google_business_vertical: 'education',
        price: product.salePrice,
        quantity: product.quantity || 1,
        course_id: product.courseId || '',
      };
    });
    payload.items = payload.items.concat(items);
  }

  if (productSaleInfo && productSaleInfo.courses) {
    const courses = productSaleInfo.courses;
    payload.course_ids = courses.map((course) => idToString(course.id)).join(',');
    payload.origin_course_ids = Array.from(new Set(courses.map((course) => course.originCourseId)))
      .map((id) => idToString(id))
      .join(',');
    payload.items = payload.items.map((item) => {
      const course = courses.find((course) => course.id === item.course_id);
      item.origin_course_id = (course && course.originCourseId) || '';
      return item;
    });
    payload.edu_pid = courses[0]?.id;
  }

  payload.edu_pagetype = 'complete';
  return payload;
};
